export default __webpack_public_path__ + "static/media/K2D-ThinItalic.e9d6ffa9.ttf";